import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import { ExternalIcon } from '../../../../../common/icons';
import HistoryModal from './HistoryModal';

import './LockUnlockPanel.css';
import AirButton from '../../../../../common/components/AirButton';
import { api } from '../../../../../services';
import AirModalTitlebar from '../../../../../common/components/AirModalTitlebar';

@withRouter
@inject('translationsStore')
@observer
export default class LockUnlockPanel extends Component {
  constructor(props) {
    super(props);
    this.itemsPerPage = 10;
    this.state = {
      visibleHistoryModal: { engine: false, door: false },
      dataSourceHistory: { engine: [], door: [] },
      dataSourceHistoryLength: { engine: 0, door: 0 },
      dataSourceHistoryCurrent: { engine: 1, door: 1 },
      dataSourceHistorySortOrder: { engine: {}, door: {} },
      vehicleHasActionOngoing: false
    };
  }

  doorAction = action => {
    const { translationsStore, car } = this.props;
    this.setState({
      visibleActionModal: true,
      modalTitle: `${translationsStore.translate('lockUnlockPanel.confirmActionTitle')} ${translationsStore.translate(`lockUnlockPanel.actions.${action}`)}?`,
      modalOnOkFunction: () => {
        if (!this.state.vehicleHasActionOngoing) {
          this.setState({vehicleHasActionOngoing: true});
          api('menage door', car.casenumber, action)
            .then(() => {
              this.setState({
                visibleMessageModalSuccess: true,
                successMessage: `${translationsStore.translate('lockUnlockPanel.success')} ${translationsStore.translate('lockUnlockPanel.successMessageDoor')}`,
                visibleActionModal: false,
                vehicleHasActionOngoing: false
              });
            })
            .catch(() => {
              this.setState({
                visibleMessageModalError: true,
                errorMessage: `${translationsStore.translate('lockUnlockPanel.error')} ${translationsStore.translate('lockUnlockPanel.errorMessage')}`,
                visibleActionModal: false,
                vehicleHasActionOngoing: false
              });
            });
        }
      }
    });
  };

  engineAction = action => {
    const { translationsStore, car } = this.props;
    this.setState({
      visibleActionModal: true,
      modalTitle: `${translationsStore.translate('lockUnlockPanel.confirmActionTitle')} ${translationsStore.translate(`lockUnlockPanel.actions.${action}`)}?`,
      modalOnOkFunction: () => {
        if (!this.state.vehicleHasActionOngoing) {
          this.setState({vehicleHasActionOngoing: true});
          api('menage engine', car.casenumber, action)
            .then(() => {
              this.setState({
                visibleMessageModalSuccess: true,
                successMessage: `${translationsStore.translate('lockUnlockPanel.success')} ${translationsStore.translate('lockUnlockPanel.successMessageEngine')}`,
                visibleActionModal: false,
                vehicleHasActionOngoing: false
              });
            })
            .catch(() => {
              this.setState({
                visibleMessageModalError: true,
                errorMessage: `${translationsStore.translate('lockUnlockPanel.error')} ${translationsStore.translate('lockUnlockPanel.errorMessage')}`,
                visibleActionModal: false,
                vehicleHasActionOngoing: false
              });
            });
        }
      }
    });
  };

  getHistory = (historyFamily, options = {}) => {
    let method = null;
    if (historyFamily === 'door') {
      method = 'getDoorControlHistory';
    }
    if (historyFamily === 'engine') {
      method = 'getEngineControlHistory';
    }
    let {
      dataSourceHistoryCurrent: { [historyFamily]: page }
    } = this.state;
    let size = this.itemsPerPage;
    if (options.hasOwnProperty('page') && options.hasOwnProperty('size')) {
      ({ page, size } = options);
    }
    const {
      dataSourceHistorySortOrder: { [historyFamily]: sortOrder }
    } = this.state;
    let { sort, order } = sortOrder,
      { car } = this.props;
    if (sort === undefined && order === undefined) {
      sort = 'recordedAt';
      order = 'DESC';
    }
    api(method, car.id, page, size, sort, order).then(response => {
      this.setState(previousState => ({
        visibleHistoryModal: { ...previousState.visibleHistoryModal, [historyFamily]: true },
        dataSourceHistory: { ...previousState.dataSourceHistory, [historyFamily]: response.rows },
        dataSourceHistoryLength: { ...previousState.dataSourceHistoryLength, [historyFamily]: response.count },
        dataSourceHistoryCurrent: { ...previousState.dataSourceHistoryCurrent, [historyFamily]: page }
      }));
    });
  };

  showHistoryModal = historyFamily => {
    const page = 1,
      size = this.itemsPerPage;
    this.getHistory(historyFamily, { page, size });
  };

  hideHistoryModal = historyFamily => {
    this.setState(previousState => ({ visibleHistoryModal: { ...previousState.visibleHistoryModal, [historyFamily]: false } }));
  };

  onHistoryModalOk = historyFamily => {
    this.hideHistoryModal(historyFamily);
  };

  onHistoryModalCancel = historyFamily => {
    this.hideHistoryModal(historyFamily);
  };

  onPageChange = (key, page, pageSize) => {
    this.getHistory(key, { page, size: pageSize });
  };

  onTableChange = (key, _, __, column) => {
    let [sort, order] = [undefined, undefined];
    if (column.hasOwnProperty('field') && column.hasOwnProperty('order')) {
      sort = column.field;
      order = column.order === 'descend' ? 'DESC' : 'ASC';
    }
    this.setState(
      previousState => ({
        dataSourceHistorySortOrder: { ...previousState.dataSourceHistorySortOrder, [key]: { sort, order } }
      }),
      () => this.getHistory(key)
    );
  };

  render() {
    const { translationsStore, car } = this.props;
    const { vehicleHasActionOngoing } = this.state;

    const columnsDoorHistory = [
      {
        key: 'command',
        dataIndex: 'command',
        title: translationsStore.translate('lockUnlockPanel.histories.columnsDoor.command'),
        sorter: true,
        render: text => translationsStore.translate(`lockUnlockPanel.histories.commandDoorLabels.${text}`)
      },
      {
        key: 'recordedAt',
        dataIndex: 'recordedAt',
        title: translationsStore.translate('lockUnlockPanel.histories.columnsDoor.recordedAt'),
        className: 'CenterNoWrap',
        width: 150,
        render: (text, record) => {
          const style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return (
            <div style={style}>
              {new Date(record.recordedAt).toLocaleDateString()} {new Date(record.recordedAt).toLocaleTimeString()}
            </div>
          );
        },
        sorter: true
      },
      {
        key: 'status',
        dataIndex: 'status',
        title: translationsStore.translate('lockUnlockPanel.histories.columnsDoor.status'),
        sorter: true,
        render: (text, record) => '-'
      }
    ];
    const columnsEngineHistory = [
      {
        key: 'command',
        dataIndex: 'command',
        title: translationsStore.translate('lockUnlockPanel.histories.columnsEngine.command'),
        sorter: true,
        render: text => translationsStore.translate(`lockUnlockPanel.histories.commandEngineLabels.${text}`)
      },
      {
        key: 'recordedAt',
        dataIndex: 'recordedAt',
        title: translationsStore.translate('lockUnlockPanel.histories.columnsEngine.recordedAt'),
        className: 'CenterNoWrap',
        width: 150,
        render: (text, record) => {
          const style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return (
            <div style={style}>
              {new Date(record.recordedAt).toLocaleDateString()} {new Date(record.recordedAt).toLocaleTimeString()}
            </div>
          );
        },
        sorter: true
      },
      {
        key: 'status',
        dataIndex: 'status',
        title: translationsStore.translate('lockUnlockPanel.histories.columnsEngine.status'),
        sorter: true,
        render: (text, record) => '-'
      }
    ];
    const paginationDoor = {
      total: this.state.dataSourceHistoryLength.door,
      current: this.state.dataSourceHistoryCurrent.door,
      defaultCurrent: 1,
      hideOnSinglePage: true,
      pageSize: this.itemsPerPage,
      simple: true,
      size: 'small',
      onChange: (page, pageSize) => this.onPageChange('door', page, pageSize)
    };
    const paginationEngine = {
      total: this.state.dataSourceHistoryLength.engine,
      current: this.state.dataSourceHistoryCurrent.engine,
      defaultCurrent: 1,
      hideOnSinglePage: true,
      pageSize: this.itemsPerPage,
      simple: true,
      size: 'small',
      onChange: (page, pageSize) => this.onPageChange('engine', page, pageSize)
    };

    return (
      <div className={'LockUnlockRowContainer'}>
        {car.doorControlEnabled && (
          <div className={'ContainerLockUnlockGroup'}>
            <div className={'LockTitle'}>
              <div>{translationsStore.translate('lockUnlockPanel.titleDoor')}</div>
              <div className="ControlHistoriesAction" onClick={() => this.showHistoryModal('door')}>
                <div>{translationsStore.translate('lockUnlockPanel.histories.labelCtaDoor')}</div>
                <ExternalIcon style={{ width: '12px', height: '12px' }} />
              </div>
            </div>
            <div className={'ButtonContainer'}>
              <AirButton className={'okButton'} light size="large" label={translationsStore.translate('lockUnlockPanel.lockDoor')} onClick={() => this.doorAction('close')} />
              <AirButton className={'okButton'} light size="large" label={translationsStore.translate('lockUnlockPanel.unlockDoor')} onClick={() => this.doorAction('open')} />
            </div>
          </div>
        )}
        {car.engineControlEnabled && (
          <div className={'ContainerLockUnlockGroup'}>
            <div className={'LockTitle'}>
              <div>{translationsStore.translate('lockUnlockPanel.titleEngine')}</div>
              <div className="ControlHistoriesAction" onClick={() => this.showHistoryModal('engine')}>
                <div>{translationsStore.translate('lockUnlockPanel.histories.labelCtaEngine')}</div>
                <ExternalIcon style={{ width: '12px', height: '12px' }} />
              </div>
            </div>
            <div className={'ButtonContainer'}>
              <AirButton className={'okButton'} light size="large" label={translationsStore.translate('lockUnlockPanel.lockEngine')} onClick={() => this.engineAction('lock')} />
              <AirButton
                className={'okButton'}
                light
                size="large"
                label={translationsStore.translate('lockUnlockPanel.unlockEngine')}
                onClick={() => this.engineAction('unlock')}
              />
            </div>
          </div>
        )}
        <AirModalTitlebar
          visible={this.state.visibleActionModal}
          cancelButton={<AirButton size="large" label={'No'} style={{ width: 240 }} />}
          okButton={<Spin spinning={vehicleHasActionOngoing}><AirButton size="large" light label={translationsStore.translate('lockUnlockPanel.okButtonText')} style={{ marginLeft: 20, width: 240 }} /></Spin>}
          onCancel={() => this.setState({ visibleActionModal: false })}
          onOk={this.state.modalOnOkFunction}
          title={this.state.modalTitle}
          titlebarStyle={{ color: 'white', backgroundColor: 'var(--primary-color)' }}
          buttonsStyle={{ justifyContent: 'center' }}
          width={560}
        />
        <AirModalTitlebar
          visible={this.state.visibleMessageModalError || this.state.visibleMessageModalSuccess}
          okButton={<AirButton size="large" light label={'Ok'} style={{ marginLeft: 20, width: 240 }} />}
          onOk={() => this.setState({ visibleMessageModalSuccess: false, visibleMessageModalError: false, visibleActionModal: false })}
          onCancel={() => this.setState({ visibleMessageModalSuccess: false, visibleMessageModalError: false, visibleActionModal: false })}
          title={this.state.visibleMessageModalError ? this.state.errorMessage : this.state.successMessage}
          titlebarStyle={{ color: 'white', backgroundColor: this.state.visibleMessageModalError ? 'red' : 'var(--primary-color)' }}
          buttonsStyle={{ justifyContent: 'center' }}
          width={560}
        />
        <HistoryModal
          visible={this.state.visibleHistoryModal.door}
          title={translationsStore.translate('lockUnlockPanel.histories.titleDoor')}
          onOk={() => this.onHistoryModalOk('door')}
          onCancel={() => this.onHistoryModalCancel('door')}
          columns={columnsDoorHistory}
          dataSource={this.state.dataSourceHistory.door}
          pagination={paginationDoor}
          onTableChange={(...args) => this.onTableChange('door', ...args)}
        />
        <HistoryModal
          visible={this.state.visibleHistoryModal.engine}
          title={translationsStore.translate('lockUnlockPanel.histories.titleEngine')}
          onOk={() => this.onHistoryModalOk('engine')}
          onCancel={() => this.onHistoryModalCancel('engine')}
          columns={columnsEngineHistory}
          dataSource={this.state.dataSourceHistory.engine}
          pagination={paginationEngine}
          onTableChange={(...args) => this.onTableChange('engine', ...args)}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/LockUnlockPanel/LockUnlockPanel.js